import React from 'react'
import { withIcon } from '../../withIcon'

function EyeShowSolidIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M12 6C17.3469 6 20.9996 11.9993 21 12C20.9993 12.0015 18.3519 18 12 18C5.70046 18 3.00048 12.0011 3 12C3 12 6.70642 6 12 6ZM12 8.18262C9.93538 8.18262 8.29493 9.87286 8.29492 12C8.29492 14.1271 9.93537 15.8174 12 15.8174C14.0646 15.8174 15.7051 14.1271 15.7051 12C15.7051 9.87286 14.0646 8.18262 12 8.18262ZM12 10.3633C12.8775 10.3633 13.5879 11.096 13.5879 12C13.5879 12.904 12.8775 13.6367 12 13.6367C11.1225 13.6367 10.4121 12.904 10.4121 12C10.4121 11.096 11.1225 10.3633 12 10.3633Z" fill={color}/>
    </svg>
  )
}

export default withIcon(EyeShowSolidIcon)
